import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { PATH_PROJECT_WITH_ID, PATH_STORE } from "@/constants";
import { PROJECT_STATUS } from "@/schemas/project";
import { STORE_STATUS } from "@/schemas/storeStatus";
import { DisplayContractorsPlannedHoursWizardAllocation } from "@/types/contractorsPlannedHoursWizard";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

export const useContractorsPlannedHoursWizardColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      project_name: {
        id: "project_name",
        meta: {
          externalPath: (row: DisplayContractorsPlannedHoursWizardAllocation) =>
            generatePath(PATH_PROJECT_WITH_ID, { projectId: row.project_id }),
        },
      },
      store_name: {
        id: "store_name",
        meta: {
          externalPath: (row: DisplayContractorsPlannedHoursWizardAllocation) =>
            generatePath(PATH_STORE, { storeId: row.store_id }),
        },
      },
      project_status: {
        id: "project_status",
        cell: ({
          row,
        }: {
          row: Row<DisplayContractorsPlannedHoursWizardAllocation>;
        }) => <>{t(`projectStatuses.${row.original.project_status}`)}</>,
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: PROJECT_STATUS,
              translationKey: "projectStatuses",
            },
          },
        },
      },
      store_status: {
        id: "store_status",
        cell: ({
          row,
        }: {
          row: Row<DisplayContractorsPlannedHoursWizardAllocation>;
        }) => <>{t(`storeStatuses.${row.original.store_status}`)}</>,
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: STORE_STATUS,
              translationKey: "storeStatuses",
            },
          },
        },
      },
    }),
    [t],
  );
};
